import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { getBooleanStatusBadgeColors } from '../utils/formatters';
import styles from './BioPage.module.scss';
export const createBioMemberColumns = ({ onMoveUp, onMoveDown, isFirst, isLast }) => [
    {
        key: 'photo',
        header: 'Photo',
        render: (member) => member.profile_image_url ? (_jsx("img", { src: member.profile_image_url, alt: "", width: 40, height: 40, style: { objectFit: 'cover', borderRadius: 4 } })) : ('N/A'),
    },
    {
        key: 'name',
        header: 'Name',
        sortable: true,
        render: (member) => (member.credentials ? `${member.name}, ${member.credentials}` : member.name),
    },
    {
        key: 'title',
        header: 'Title',
        sortable: true,
        render: (member) => member.title || 'N/A',
    },
    {
        key: 'is_active',
        header: 'Active',
        sortable: true,
        render: (member) => {
            const label = member.is_active ? 'Active' : 'Inactive';
            const { background, text } = getBooleanStatusBadgeColors(!!member.is_active);
            return _jsx(StatusBadge, { label: label, bgColor: background, color: text });
        },
    },
    {
        key: 'order',
        header: 'Order',
        render: (member) => (_jsxs("div", { className: styles.reorderGroup, onClick: (event) => event.stopPropagation(), children: [_jsx("button", { type: "button", className: styles.reorderButton, "aria-label": `Move ${member.name} up`, title: `Move ${member.name} up`, disabled: isFirst(member), onClick: () => onMoveUp(member), children: "\u25B2" }), _jsx("button", { type: "button", className: styles.reorderButton, "aria-label": `Move ${member.name} down`, title: `Move ${member.name} down`, disabled: isLast(member), onClick: () => onMoveDown(member), children: "\u25BC" })] })),
    },
];
